/*
 * Button to expand the accordion component and show filters options
 */
import React from 'react'
import Button from 'react-bootstrap/Button'

const FiltersBtn = ({ handleClick, disabled }) => {
  return (
    <Button
      variant='normal'
      className='filters-btn border-0 m-2'
      onClick={handleClick}
      disabled={disabled}
    >
      <i className='fas fa-sliders-h mr-2' />
      Filters
    </Button>
  )
}

export default FiltersBtn
